// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"XP-z","loadingMedia":"YP-z","reviewsImagesAndVideos":"ZP-z","limitHeight":"_P-z"};